import { z } from "zod";
import { schemes } from "../../schema-validation";

const baseSchema = z.object({
  companyID: schemes.uuid().optional(),
  workLocationId: schemes.uuid().optional(),
  quarkWorkLocationId: schemes.mongoObjectId(),
  quarkTaxableLocationId: schemes.mongoObjectId(),
  street1: z.string(),
  street2: z.string().optional(),
  city: z.string(),
  workSiteId: z.string().optional(),
  name: z.string().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
});

const usSchema = baseSchema.extend({
  state: schemes.jurisdiction(),
  zip: schemes.zipCode(),
  country: z.literal("US"),
});

const caSchema = baseSchema.extend({
  country: z.literal("CA"),
  province: z.string(),
  postal_code: z.string(),
});

export const laForgeWorkLocationSchema = z.discriminatedUnion("country", [
  usSchema,
  caSchema,
]);

export type LaForgeWorkLocation = z.infer<typeof laForgeWorkLocationSchema>;
